// packages
import { jwtDecode } from 'jwt-decode';
// lib
import { getAuthToken } from "./localStorage";
import isEmpty from "./isEmpty";

export const decodeJWT = (token) => {
    try {
        const decoded = jwtDecode(token.replace('Bearer ', ''));
        if (isEmpty(decoded)) {
            return {
                status: false
            };
        }
        return {
            status: true,
            decoded
        }
    } catch (err) {
        return {
            status: false
        }
    }
}

export const isLogin = () => {
    try {
        let token = getAuthToken();
        if (isEmpty(token)) return false;
        const { status } = decodeJWT(token)
        if (!status) return false;
        return true;
    } catch (err) {
        return false;
    }
}